import { apiClient } from "features/shared/api/axiosInstance";

export const fileApi = {
    uploadFile: (file: File, path: string) => {
        const formData = new FormData();
        formData.append("file", file);
        return apiClient.post<string>(`/api/file/${path}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },

    uploadPartnersTemplate: (file: File, programAddress: string) => {
        const formData = new FormData();
        formData.append("file", file);
        return apiClient.post(`/api/file/template/${programAddress}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};
